import React, { useEffect, useMemo } from 'react';
import { Props } from './CaseListingPage.types';
import styles from './CaseListingPage.module.scss';
import useBodyClass from 'helpers/hooks/useBodyClass';
import { Box, Tabs } from 'modules/af_cm_ui_kit';
import CaseListingItem from './partials/CaseListingItem/CaseListingItem';
import { useHistory } from 'react-router-dom';
import { caseManagement } from '../../../../routes/routePaths';
import { fetchCases } from 'modules/cm/store/casesListing/actions';
import { useDispatch, useSelector } from 'react-redux';
import { State } from '../../store/casesListing/types';
import Spinner from '../../../../shared/Spinner/Spinner';

const CaseListingPage: React.FC<Props> = ({ userName }) => {
  const dispatch = useDispatch();
  useBodyClass(...styles['new-cm'].split(' '));
  const history = useHistory();
  const casesState = useSelector(({ cases }: { cases: State }) => cases);
  const tabstatus = useMemo(() => {
    return ['active', 'valuation', 'offered', 'completed', 'withdrawn'];
  }, []);

  const redirectToCaseDetails = (caseId: string): void => {
    history.push(`${caseManagement.index}/${caseId}`);
  };
  const redirectToCaseTask = (caseId: string, e: React.MouseEvent<HTMLDivElement, MouseEvent>): void => {
    e.stopPropagation();
    history.push(`${caseManagement.index}/${caseId}/tasklist`);
  };
  const caseListingTab = () => (
    <div>
      {casesState.isPending && <Spinner />}
      {casesState.isLoaded &&
        casesState.data &&
        casesState.data.cases.map((caseItem) => (
          <CaseListingItem
            key={caseItem.caseId}
            caseItem={caseItem}
            onItemClick={() => redirectToCaseDetails(caseItem.caseId)}
            onTaskCounterClick={(e) => redirectToCaseTask(caseItem.caseId, e)}
          />
        ))}
    </div>
  );

  const loadCases = (activeTab: number) => {
    dispatch(fetchCases(tabstatus[activeTab]));
  };

  useEffect(() => {
    dispatch(fetchCases(tabstatus[0]));
  }, [tabstatus, dispatch]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.heading}>
        <div className={styles.container}>
          <p className={styles.greeting}>Hello</p>
          <p className={styles.user}>{userName}</p>
        </div>
      </div>

      <Box title="Case management">
        <Tabs
          onTabChange={loadCases}
          labels={[
            { value: 'Active', hasError: false },
            { value: 'Valuation', hasError: false },
            { value: 'Offered', hasError: false },
            { value: 'Completed', hasError: false },
            { value: 'Withdrawn', hasError: false },
          ]}
          tabsContentGap={0}
          isDisabled={casesState.isPending}>
          {caseListingTab()}
          {caseListingTab()}
          {caseListingTab()}
          {caseListingTab()}
          {caseListingTab()}
          {casesState.isPending && <Spinner />}
        </Tabs>
      </Box>
    </div>
  );
};

export default CaseListingPage;
